import {
  FetchCommentByContextFailureAction,
  FetchCommentByContextRequestAction,
  FetchCommentByContextSuccessAction,
  PlanActionsContext,
  StrapiActionTypes,
  UploadFileFailureAction,
  UploadFileRequestAction,
  UploadFileSuccessAction,
} from '../../types/types';

export const uploadFileRequest = (file: File, refId: number, title: string): UploadFileRequestAction => ({
  type: StrapiActionTypes.UPLOAD_FILE_REQUEST,
  payload: {
    file,
    refId,
    title,
  },
});

export const uploadFileSuccess = (data: any): UploadFileSuccessAction => ({
  type: StrapiActionTypes.UPLOAD_FILE_SUCCESS,
  payload: {
    data,
  },
});

export const uploadFileFailure = (error: string): UploadFileFailureAction => ({
  type: StrapiActionTypes.UPLOAD_FILE_FAILURE,
  payload: {
    error,
  },
});

export const fetchCommentByContextRequest = (modelName: string, context: PlanActionsContext): FetchCommentByContextRequestAction => ({
  type: StrapiActionTypes.FETCH_COMMENT_BY_CONTEXT_REQUEST,
  payload: { modelName, context },
});

export const fetchCommentByContextSuccess = (data: any[]): FetchCommentByContextSuccessAction => ({
  type: StrapiActionTypes.FETCH_COMMENT_BY_CONTEXT_SUCCESS,
  payload: { data },
});

export const fetchCommentByContextFailure = (error: string): FetchCommentByContextFailureAction => ({
  type: StrapiActionTypes.FETCH_COMMENT_BY_CONTEXT_FAILURE,
  payload: { error },
});
